import React, { useState ,useContext} from 'react'
import Card from "@mui/material/Card";
import { CardHeader, Icon } from '@mui/material';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SearchStringOrIntReq from '../../../../Classes/Models/Requests/SearchStringOrIntReq';
import Swal from 'sweetalert2';
import DateTimePicker from 'react-datetime-picker';
import SessionsApi from '../../../../Classes/API/Administration/SessionsApi';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import { LanguageContext } from "App";
const NotesAndStartDate = ({ Package, setIsLoaded }) => {

    const [StartDate, setStartDate] = useState(new Date(Package.startDate))
    const [Notes, setNotes] = useState(Package.notes)
    const {translations} = useContext(LanguageContext)
    const UpdatePackage = async () => {

        Swal.fire({
            title: 'Updating Package',
            text: "Please wait...",
            icon: 'info',
            // allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: async () => {
                Swal.showLoading()
            }
        })


        let req = new SearchStringOrIntReq();
        req.SearchInt = Package.id;
        req.SearchString = Notes;
        let date = new Date(StartDate);
        date.setHours(14, 0, 0, 0);
        req.SearchDate = StartDate;

        let res = await SessionsApi.UpdatePackageNotesAndStartDate(req);
        if (res.status == "Success") {
            Swal.fire({
                title: "Success",
                text: "Package updated successfully",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
                didOpen: async () => {
                    Swal.hideLoading()
                }
            })
            setIsLoaded(false);
        }
        else {
            Swal.fire({
                title: "Error",
                text: res.message,
                icon: "error",
                showConfirmButton: false,
                timer: 1500,
                didOpen: async () => {
                    Swal.hideLoading()
                }
            })
        }

    }






    return (
        <Card sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em" }}>

            <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
                <MDTypography variant="h6" fontWeight="medium">
                    {translations.PackageInfoNotesandStartDate}
                </MDTypography>
                <MDButton onClick={() => UpdatePackage()} variant="gradient" color="info">
                    <Icon sx={{ fontWeight: "bold" }}>update</Icon>
                    &nbsp;{translations.PackageInfoUpdate}
                </MDButton>
            </MDBox>


            <div className="container-fluid p-5">
            <MDTypography variant="h6">Start Date ({new Date(StartDate).toLocaleDateString()})</MDTypography>

                <div className="row"
                    style={{ display: "flex", alignItems: "center" }}
                >

                    <div className="col-md-4">
                        <MDInput type="date" value={new Date(StartDate).toLocaleDateString()} onChange={(e) => setStartDate(e.target.value)} className="w-100" />
                    </div>


                    <div className="col-md-8">
                        <textarea
                            placeholder={translations.PackageInfoNote}
                            value={Notes}
                            onChange={(e) => setNotes(e.target.value)}
                            style={{ width: "100%", height: "50px", padding: "10px" }}
                        />
                    </div>


                </div>
            </div>



        </Card>
    )
}

export default NotesAndStartDate